import { AppName, Platform,Release, ReleaseAsset } from "@/entities/releases/releases.types"

import { APIDocsSwagger } from "../APIStable"

export function mapRelease(
  release: typeof APIDocsSwagger.schemas.Release._plain & { _id?: string },
): Release {
  return {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    id: (release as any)._id || "",
    appName: release.appName as AppName,
    version: release.version,
    githubReleaseId: release.githubReleaseId,
    tagName: release.tagName,
    assets: release.assets.map(mapReleaseAsset),
    releaseNotes: release.releaseNotes,
    publishedAt: new Date(release.publishedAt),
    prerelease: release.prerelease,
    draft: release.draft,
    githubUrl: release.githubUrl,
    syncedAt: new Date(release.syncedAt),
    createdAt: new Date(release.createdAt),
    updatedAt: new Date(release.updatedAt),
  }
}

function mapReleaseAsset(
  asset: typeof APIDocsSwagger.schemas.ReleaseAsset._plain,
): ReleaseAsset {
  return {
    name: asset.name,
    s3Key: asset.s3Key,
    size: asset.size,
    platform: asset.platform as Platform,
    contentType: asset.contentType,
    githubAssetId: asset.githubAssetId,
    signature: asset.signature,
  }
}
